import { useState } from "react";

import { Button } from "@mui/material";

import AutosizeTextarea from "../utils/AutosizeTextarea";
import { SnackbarNotification } from "../utils/Notifications";

import "./css/new-answer.css";

import { createAnswer } from "../../functions/server-requests/answer";

const NewAnswer = ({
  doubtId,
  answeredById,
  answeredBy,
  answeredByRole,
  answers,
  setAnswers
}) => {
  const [answerBody, setAnswerBody] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("success");
  const [message, setMessage] = useState("");
  const [isSubmitting, setSubmitting] = useState(false);

  const handleAnswer = (e) => {
    setAnswerBody(e.target.value);
  }

  const handleSubmit = async () => {
    setSubmitting(true);

    const data = {
      doubtId,
      answeredById,
      answeredBy,
      answeredByRole,
      answerBody: answerBody.trim()
    };

    const createAnswerRes = await createAnswer(data);

    if (createAnswerRes.status === 201) {
      setAnswers([
        ...answers,
        createAnswerRes.data.answerDetails
      ]);
      setAnswerBody("");
      setSeverity("success");
    }
    else {
      setSeverity("error");
    }

    setMessage(createAnswerRes.data.message);
    setOpenSnackbar(true);
    setSubmitting(false);
  }

  return (
    <>
      <div className="new-answer">
        <AutosizeTextarea
          textFor="answer"
          text={answerBody}
          handleText={handleAnswer}
          disabled={isSubmitting}
        />

        <div className="new-ans-action">
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={
              isSubmitting ||
              (answerBody.trim().length < 2 ||
              answerBody.trim().length > 2048)
            }
          >
            {!isSubmitting
              ? "Submit"
              : "Submitting ..."
            }
          </Button>
        </div>
      </div>

      <SnackbarNotification
        openSnackbar={openSnackbar}
        setOpenSnackbar={setOpenSnackbar}
        severity={severity}
        message={message}
      />
    </>
  );
}

export default NewAnswer;